export const ESCOLARIDADE = [
  "FUNDAMENTAL_INCOMPLETO",
  "FUNDAMENTAL_COMPLETO",
  "MEDIO_INCOMPLETO",
  "MEDIO_COMPLETO",
  "TECNICO",
  "SUPERIOR_INCOMPLETO",
  "SUPERIOR_COMPLETO",
  "POS_GRADUACAO",
  "MESTRADO",
  "DOUTORADO",
  "PHD",
] as const;

export type ESCOLARIDADE_TYPE = (typeof ESCOLARIDADE)[number];
